import { toJS } from '@rehaje/reactive'
import { getIterableKeys, toJSON } from '@rehaje/shared'

import type { TRecord } from '@rehaje/shared'

export function toJSByIterableKeys<T = TRecord>(
  target: TRecord,
  visitor = toJS.visitor
): T {
  return toJS.traverse(target, (value, toJS) => {
    if (typeof visitor === 'function') return visitor(value, toJS)
    const obj: TRecord = {}
    for (const key of getIterableKeys(value)) {
      obj[key] = toJS(value[key])
    }
    return obj
  })
}

export function toJSONByIterableKeys<T = TRecord>(
  target: TRecord,
  visitor = toJSON.visitor
): T {
  return toJSON.traverse(target, (value, toJSON) => {
    if (typeof visitor === 'function') return visitor(value, toJSON)
    const obj: TRecord = {}
    for (const key of getIterableKeys(value)) {
      obj[key] = toJSON(value[key])
    }
    return obj
  })
}
